// Small SVG badge showing which Eisenhower quadrant a task belongs to.
// Renders a 2×2 grid with the selected quadrant filled white and the others outlined.
// Quadrant keys: "ui" (Urgent & Important), "u" (Urgent), "i" (Important), "s" (Spare time).
export const EisenBadge = ({ q, size = 12, title }: { q?: string; size?: number; title?: string }) => {
  if (!q) return null;
  const s = size;
  const half = s / 2;
  const cells = [
    { k: "ui", x: 0, y: 0 },
    { k: "u", x: half, y: 0 },
    { k: "i", x: 0, y: half },
    { k: "s", x: half, y: half },
  ];
  return (
    <svg
      width={s}
      height={s}
      viewBox={`0 0 ${s} ${s}`}
      shapeRendering="crispEdges"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
      }}
      {...({ title } as any)}
    >
      {cells.map((c) => (
        <rect
          key={c.k}
          x={c.x + 0.5}
          y={c.y + 0.5}
          width={half - 1}
          height={half - 1}
          fill={c.k === q ? "var(--tp)" : "none"}
          stroke="var(--tp)"
          strokeWidth="1"
        />
      ))}
    </svg>
  );
};

// English-canonical fallback. Phase M+3.7 routes the live value through
// the eisenhower_quadrant taxonomy via eisenLabel(q). Reads of EISEN_LABELS
// stay valid as a synchronous fallback during first paint.
export const EISEN_LABELS = {
  ui: "Urgent & Important",
  u: "Urgent",
  i: "Important",
  s: "Spare time",
};

// Wrap EISEN_LABELS in a Proxy so existing `EISEN_LABELS[q]` reads
// transparently consult the loaded taxonomy first. The Proxy returns the
// active-language label when present, falling back to the English literal.
// Side effect: the bundled EISEN_LABELS export above stays a usable object
// reference (Object.keys etc.); the live read goes through window.__lxEisen
// which the EisenLabelsLoader populates on mount.
const EN: Record<string, string> = {
  ui: "Urgent & Important",
  u: "Urgent",
  i: "Important",
  s: "Spare time",
};
export function eisenLabel(q?: string) {
  if (!q) return "";
  if (typeof window !== "undefined" && window.__lxEisen) {
    const lang = window.__lxLang || "en";
    const e = window.__lxEisen[q];
    if (e) {
      if (lang === "fr" && e.labelFr) return e.labelFr;
      if (lang === "nl" && e.labelNl) return e.labelNl;
      return e.labelEn || e.label || EN[q] || q;
    }
  }
  return EN[q] || q;
}
